import React from 'react';
import { createComponent as cc } from 'react-fela';

import { COLORS, LINKS } from '../util/constants';

const SocialLinksWrapper = cc(_ => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  height: '10vh',
  small: {},
}));

const SocialLink = cc(
  ({ href }) => ({
    color: COLORS.GOLD,
    textDecoration: 'none',
    padding: '20px',
    width: '33%',
  }),
  'a',
  ['href', 'target']
);

const SocialLinks = () => (
  <SocialLinksWrapper>
    <SocialLink
      target='_blank'
      className={ 'socicon-facebook' }
      href={ LINKS.FACEBOOK } />
    <SocialLink
      target='_blank'
      className={ 'socicon-instagram' }
      href={ LINKS.INSTAGRAM } />
    <SocialLink
      target='_blank'
      className={ 'socicon-twitter' }
      href={ LINKS.TWITTER } />
  </SocialLinksWrapper>
);

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/SocialLinks.js